<template>
  <OrderDetailCustomerCenter
    :orderDetailStatus="orderDetailStatus"
    :customerCenterLog="customerCenterLog"
    :customerServiceTelephoneNumber="customerServiceTelephoneNumber"
  />
</template>

<script>
import OrderDetailCustomerCenter from '../../layouts/organisms/OrderDetailCustomerCenter/index'
import { LogScreenName, LogType, LogGroup, LogEvent } from '@/plugins/AppLogManager'

export default {
  name: 'OrderDetailCustomerCenterContainer',
  components: { OrderDetailCustomerCenter },
  computed: {
    orderDetailStatus() {
      return (
        this.$store.getters['myOrderHistoryDetailV2/orderDetail'].summary.status || 'DELIVERING'
      )
    },

    customerServiceTelephoneNumber() {
      return this.$store.getters['myOrderHistoryDetailV2/customerServiceTelephoneNumber']
    }
  },
  methods: {
    customerCenterLog() {
      const { orderId, shopId } = this.$store.getters['myOrderHistoryDetailV2/orderDetail'].summary

      const params = {
        OrdNo: String(orderId),
        ShopNo: String(shopId)
      }

      // M5-1
      this.$appLogManager.post({
        screenName: LogScreenName.MARKET_ORD_DET,
        type: LogType.CLICK,
        group: LogGroup.CALL,
        event: LogEvent.CENTER_CALL,
        params
      })
    }
  }
}
</script>

